import styled from "styled-components";

import BaseCaptionContainer from "./withcaption/CaptionContainer";
import * as scCaption from "./withcaption/CaptionContainer.sc";

export const CaptionContainer = styled(BaseCaptionContainer)`
    & ${scCaption.Caption} {
        margin-bottom: 6px;
    }

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        margin-top: 0;
        padding: 0;
    }
`;
